<template>
  <div>
    <SectionTitle :label="$t('label.termsOfService')" text-class="primary--text text--darken-1" />
    <div v-html="agentTermsAndConditions" class="scrollable-text-section" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import SectionTitle from '@/components/SectionTitle.vue'
export default {
  components: { SectionTitle },
  computed: {
    ...mapGetters('page', ['agentTermsAndConditions'])
  }
}
</script>
